<article class="meeting-card-half"
         [class.mobile]="deviceService.isMobile()"
         itemscope itemtype="https://schema.org/Article">
  <div *ngIf="isBrowser" class="card-cover" (click)="onOpenCardInModal()"></div>

  <ng-container *ngTemplateOutlet="meta"></ng-container>

  <div class="top-info">
    <div class="teacher-block">
      <div class="teacher-wrap">
        <a class="avatar-wrap" [routerLink]="authorUrl">
          <ng-template [ngIf]="userpicUrl" [ngIfElse]="noAvatar">
            <img [src]="userpicUrl" [alt]="userpicFullname" class="avatar">
          </ng-template>
          <ng-template #noAvatar>
            <app-icon icon="guest"></app-icon>
          </ng-template>
        </a>
        <span class="teacher-name normal">{{ userpicFullname }}</span>
      </div>

      <ng-container *ngTemplateOutlet="ratingWrap"></ng-container>
    </div>
    <div class="meeting-info">
      <a [routerLink]="meetingRoute" class="cover-wrap" [class.no-cover]="!coverImageUrl">
        <ng-template [ngIf]="coverImageUrl" [ngIfElse]="noCover">
          <img [src]="coverImageUrl"
               [attr.alt]="fullTitle"
               [attr.title]="fullTitle"
               class="cover">
        </ng-template>

        <ng-template #noCover>
          <app-icon width="70" height="70" icon="no-cover"
               [attr.alt]="fullTitle"
               [attr.title]="fullTitle">
          </app-icon>
        </ng-template>
      </a>
      <a [routerLink]="meetingRoute" [attr.title]="fullTitle" class="info-block">
        <i class="subject-wrap">
          <span class="subject bold">{{ subjectTitle }}</span>
          <ng-template [ngIf]="subjectIsNative">
            <span class="native normal">{{ 'library.user-service-card.native' | customLocale }}</span>
          </ng-template>
        </i>
        <div class="title bold">{{ title }}</div>
        <span class="category normal">{{ typeTitle }}</span>
      </a>
    </div>
    <div class="card-details">
      <span class="label normal">{{ 'Date:' | customLocale }}</span>
      <span class="value normal">{{ begin_at | dfnsFormat: 'dd MMMM yyyy HH:mm' }}</span>

      <span class="label normal">{{ 'Participants:' | customLocale }}</span>
      <span class="value normal">
        {{ meeting?.participants_limit - meeting?.has?.participantsLeft }}/{{ meeting?.participants_limit }}
      </span>
    </div>
  </div>
  <div class="actions-block">
    <div class="price-wrap">
      <span class="price bold">{{ getFormattedPrice(price_tier) | async }}</span>
    </div>
    <on-ui-button class="secondary"
                  label="library.user-service-card.sign-up-for-a-lesson"
                  (onclick)="goSignup($event)">
    </on-ui-button>
  </div>
</article>

<ng-template #meta>
  <meta itemprop="url" content="{{ meetingRoute }}"/>
  <meta itemprop="name" content="{{ fullTitle }}"/>
  <meta itemprop="datePublished" content="{{ hlp_dateToISOString(contentDate) }}"/>
  <meta itemprop="image" content="{{ metaImageUrl || coverImageUrl }}"/>
  <meta *ngIf="description" itemprop="description" content="{{ description | striptags }}"/>
  <meta itemprop="headline" content=""/>
  <!-- <meta itemprop="publisher" content="htts://onclass.com"/> -->
  <!-- keywords -->
  <meta itemprop="inLanguage" content="{{ meeting?.language?.code }}"/>
  <!-- discussionUrl -->
  <!-- <meta *ngIf="service.stats?.comments_count" itemprop="commentCount" content="{{ service.stats?.comments_count }}"/>-->
</ng-template>

<ng-template #ratingWrap>
  <app-rating [stats]="authorStats"></app-rating>
</ng-template>
